import { useEffect, useState } from 'react';
import { Underage } from '../../../types/user';
import { concatenateStringList } from '../../../util/formatItens';

import { LinkWithRoleButton } from '../../../components/Link/LinkWithRoleButton';
import { Actions, Categories } from '../../../types/gtm';
import { ItemSignature, TitleProduct } from '../styles';
import Icon from '../../../components/Section/Icon';
import svg from '../../../static/img/icon-open-menu.svg';
import environmentConfig from '../../../config/environment-configs';

export const ItemWebParental = ({
  underages,
  globoId,
}: {
  underages: Underage[];
  globoId: string;
}) => {
  const [namesUnderage, setNamesSignatures] = useState<string[]>([]);

  useEffect(() => {
    if (underages && underages.length > 0) {
      const names = underages.map(s => s.name.split(' ')[0]);
      setNamesSignatures(names);
    }
  }, [underages]);

  if (namesUnderage.length === 0) {
    return <></>;
  }

  function handleRedirect() {
    window.location.href = `${environmentConfig.ACCOUNT_MANAGEMENT_DEFAULT_DNS_URL}/controle-parental`;
  }

  return (
    <ItemSignature key={`parental-web-${String(namesUnderage?.length)}`}>
      <TitleProduct>{concatenateStringList(namesUnderage)}</TitleProduct>
      <p>
        Acesse a página do <strong>controle parental </strong> para excluir as
        conta dos menores autorizados por você.
      </p>
      <LinkWithRoleButton
        onClick={() => {
          window.dataLayer.push({
            event: 'customEventUserInteraction',
            event_category: Categories.DeleteAccount,
            event_action: Actions.ClickParentalControl,
            bd_suser_code: globoId,
          });

          handleRedirect();
        }}
      >
        Controle Parental
        <Icon svg={svg} alt="icon-open-menu" />
      </LinkWithRoleButton>
    </ItemSignature>
  );
};
